import StoreLocatorPage from "../pages/StoreLocatorPage";
import styled from "styled-components";

const StlWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    margin: 100px auto 70px auto;
  }
`;

const D9StoreFinderSlice = (props) => {
  return (
    <StlWrapper>
      <StoreLocatorPage brand="Good News - Hemp" customStyles={true} />
    </StlWrapper>
  );
};

export default D9StoreFinderSlice;
